const state = {
  total_count: 0,
  school_list: [{
    slug: '',
    full_name: '',
    gender: 'male',
    grade: 1,
    head_student_name: '',
    head_student_slug: '',
    platoon_name: '',
    platoon_slug: '',
    member_count: 0,
    is_active: true,
  }],
  school: {
    editable: false,
    slug: '',
    name: '',
    logo: '',
    address: '',
    phone_number: '',
    has_basij: false,
    has_red_crescent: false,
    has_st_org: false,
    longitude: 0,
    latitude: 0,
    is_active: false,
    rate: null,
    gender: '',
    grade: 0,
    shift: '',
    school_type: '',
    management_type: '',
    student_count: 0,
    room_count: 0,
    importance: '',
    zone: '',
    city: 0,
    province: 0,
    city_name: '',
    province_name: '',
    platoon_name: '',
    platoon_slug: '',
    platoon_rasa: false,
    deputy: {name: '', slug: ''},
    headmaster: {name: '', slug: ''},
    members: [{id: 0, role: '', name: '', gpa: '', days: 0, status: '', slug: ''}]
  },
}

const getters = {
  SchoolList: state => state.school_list,
  SchoolTotalCount: state => state.total_count,
  School: state => state.school,
}

const mutations = {
  setSchool(state, payload) { state.school=payload.school; state.school.editable=payload.editable; state.school.members=payload.members },
  setSchoolList(state, payload) { state.school_list=payload.list; state.total_count=payload.total_count },
  setSchoolListPush(state, payload) { state.school_list=state.school_list.concat(payload.list); state.total_count=payload.total_count },
  setSchoolActivity(state, payload) { state.school.is_active=payload },
  setSchoolActivityInSchoolList(state, payload) { state.school_list[state.school_list.map(item => item.slug).indexOf(payload.slug)].is_active=payload.is_active },
  setSchoolLogo(state, payload) { state.school.logo=payload },
  setSchoolLogoInSchoolList(state, payload) { state.school_list[state.school_list.map(item => item.slug).indexOf(payload.slug)].logo=payload.logo },
  setMembersInYear(state, payload) { state.school.members=payload },
  setRemoveMemberInSchool(state, payload) { state.school.members.splice(state.school.members.map(item => item.id).indexOf(payload),1) },
  setArchiveMemberInSchool(state, payload) { state.school.members[state.school.members.map(item => item.id).indexOf(payload)].status='inactive' },
  setNewMemberInSchool(state, payload) { state.school.members.push(payload) },
  setSchoolUpdate(state, payload) {
    state.school.name=payload.name;
    state.school.address=payload.address;
    state.school.phone_number=payload.phone_number;
    state.school.has_basij=payload.has_basij;
    state.school.has_st_org=payload.has_st_org;
    state.school.has_red_crescent=payload.has_red_crescent;
    state.school.longitude=payload.longitude;
    state.school.latitude=payload.latitude;
    state.school.shift=payload.shift;
    state.school.school_type=payload.school_type;
    state.school.management_type=payload.management_type;
    state.school.student_count=payload.student_count;
    state.school.room_count=payload.room_count;
    state.school.importance=payload.importance;
    state.school.zone=payload.zone;
    },
  setSchoolHeadmaster(state, payload) { state.school.headmaster=payload },
  setSchoolDeputy(state, payload) { state.school.deputy=payload },
}

const actions = {
}

export default {
  state,
  getters,
  mutations,
  actions
}
